import { FC, useState, useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ApiKeyTableRow from './ApiKeyTableRow';
import { Box } from '@mui/material';
import { ApiKey } from '../types/api-key-types';

const ApiKeysTable: FC<React.PropsWithChildren<ApiKeysTableProps>> = ({
  apiKeys,
  isUserAdminRole,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = useCallback((_: unknown, newPage: number) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Box component={Paper} width='100%'>
      <TableContainer>
        <Table stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              <TableCell key='keyName'>API Key Name</TableCell>
              <TableCell key='keyType'>Key Type</TableCell>
              <TableCell key='createdBy'>Created By</TableCell>
              <TableCell key='createdAt'>Created At</TableCell>
              <TableCell key='expiration'>Expiration Date</TableCell>
              <TableCell key='lastUsed'>Last Used</TableCell>
              <TableCell key='status'>Status</TableCell>
              <TableCell key='actions'></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apiKeys
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(apiKey => (
                <ApiKeyTableRow
                  key={apiKey.id}
                  apiKey={apiKey}
                  isUserAdminRole={isUserAdminRole}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component='div'
        count={apiKeys.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export interface ApiKeysTableProps {
  apiKeys: ApiKey[];
  isUserAdminRole: boolean;
}

export default ApiKeysTable;
